import { createReducer } from '@reduxjs/toolkit'

import { KpiVariable } from 'types/GlobalKpiVariable'

import { insertItems, removeItem } from 'redux/utils'

import * as actions from '../../actions/KpiVariables/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type KpiVariableBody = { [key: string]: KpiVariable }

export interface KpiVariableReducerType {
  data: KpiVariableBody
  fetched: boolean
  fetching: boolean
}

// Initial state
const INITIAL_STATE: KpiVariableReducerType = {
  data: {},
  fetched: false,
  fetching: false
}

// Reducer
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetching = true
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload.data)
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetching = false
    })
    .addCase(actions.putSortSuccess, (state, action) => {
      state.data = insertItems(action.payload.data)
      state.fetched = true
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.destroySuccess, (state, action) => {
      state.data = removeItem(state.data, action.payload.id)
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
